module.exports = __webpack_public_path__ + "static/media/panda.81d7d72e.png";